// extracted by mini-css-extract-plugin
export default {"kategorySetting":"kategorySetting_kategorySetting__MWqeS","kategorySetting_title":"kategorySetting_kategorySetting_title__Cfp9J"};